module.exports = __webpack_public_path__ + "media/images/campsite-og-6efcc46fb75fc94baea210586964fc0f.jpg";